var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1130,
    height: 40,
    viewBox: "0 0 1130 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M572.15 33.2754L565.24 39.7202L558.41 33.2754M572.15 33.2754L565.24 26.6109L558.41 33.2754M572.15 33.2754L1130 0L660.008 33.2754H572.15ZM558.41 33.2754L0 0L470.238 32.9825L558.41 33.2754Z",
    fill: "#7C001F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M572.15 33.2754L565.24 39.7202L558.41 33.2754M572.15 33.2754L565.24 26.6109L558.41 33.2754M572.15 33.2754L1130 0L660.008 33.2754H572.15ZM558.41 33.2754L0 0L470.238 32.9825L558.41 33.2754Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedLogo);
export default __webpack_public_path__ + "static/media/FeaturedLogo.b70ec0cb956d684e082fac5fb31b596a.svg";
export { ForwardRef as ReactComponent };